import styled from 'styled-components';

export const SubheaderText = styled.h1<{ weight?: string }>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  font-size: 15.5px;
  font-weight: 400;
  margin-bottom: 15px;
`;
